export { default as useCheckIsAdmin } from './use-check-is-admin'
